import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';
import { selectCurrentDevice, selectCurrentDeviceStatus } from 'src/app/store/device/device.selector';
import { Device } from 'src/app/model/device';
import { DeviceStatus } from 'src/app/model/device-status';

@Component({
	selector: 'app-retry-init',
	templateUrl: './retry-init.component.html',
	providers: [],
})
export class RetryInitComponent  implements OnInit, OnDestroy  {
	// FROM GATEWAY-CONSTANTS
	// UNCONFIGURED: 255 or ERROR: 1 -> RED
	// DONE: 0, -> GREEN
	// OTHERS -> PROGRESS SPINNER
	
	owned: boolean;
	errorConfig: boolean = false;
	successConfig: boolean = false;
	loadingConfiguration: boolean = true;

	description: string = '';

	device: Device;
	device$: Observable<Device | undefined>;
	deviceSub: Subscription | undefined;

	deviceStatus: DeviceStatus;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.device$ = this.store.select(selectCurrentDevice);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.translate.onLangChange.subscribe(() => {
			this.getDescription();
		});
	}

	subscribeAll(): void {
		this.deviceSub = this.device$?.subscribe(
			(device) => {
				this.device = device;
				this.owned = device.CurrentlyOwned;
			}
		);
		this.deviceStatusSub = this.deviceStatus$?.subscribe(
			(deviceStatus) => {
				this.deviceStatus = deviceStatus;
				if (deviceStatus) {
					if (deviceStatus.Configured === 0) { // DONE
						this.errorConfig = false;
						this.successConfig = true;
						this.loadingConfiguration = false;
					} else if (deviceStatus.Configured === 1 || deviceStatus.Configured === 255) { // ERROR CONFIG
						this.errorConfig = true;
						this.successConfig = false;
						this.loadingConfiguration = false;
					} else { // ALL OTHER STATE -> PROGRESS SPINNER
						this.errorConfig = false;
						this.successConfig = false;
						this.loadingConfiguration = true;
					}
					this.getDescription();
				}
			}
		);
	}

	ngOnDestroy(): void {
		this.deviceSub?.unsubscribe();
		this.deviceStatusSub?.unsubscribe();
	}

	canReconfigure(): boolean {
		return this.owned && this.errorConfig;
	}

	getColorCard(): string {
		if (this.errorConfig) {
			return 'bg-red-200';
		} else if (this.successConfig) {
			return 'bg-green-100';
		} else { // (this.loadingConfiguration)
			return 'bg-blue-200';
		}
	}

	getDescription(): void {
		if (this.errorConfig) {
			this.description = this.translate.instant('Configurazione terminata con errore');
		} else if (this.successConfig) {
			this.description = this.translate.instant('Dispositivo configurato');
		} else { // (this.loadingConfiguration)
			this.description = this.translate.instant('LOADING_CONFIG');
		}
	}

	retryInit(): void {
		this.store.dispatch(DeviceActions.initDevice({}));
		this.errorConfig = false;
		this.successConfig = false;
		this.loadingConfiguration = true;
		this.getDescription();
		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'new_retry_init', params: { page_title: 'Device' } }));
		}, 2000);
	}
}